import { bool, number, oneOfType, shape, string } from 'prop-types'

export const AffiliateType = shape({
	link: string,
	name: string,
})

export const ThumbnailType = shape({
	isBlurred: bool,
	path: string,
})

export const CategoryType = shape({
	slug: string,
	thumbnail: ThumbnailType,
	title: string,
	url: string,
})

export const PricingType = shape({
	isFeatured: bool,
	selected: string,
	primary: bool,
	rank: number,
	affiliate: AffiliateType,
	widgetId: oneOfType([string, number]),
})
